import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { RichTextEditor, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { VariablePickerPopover } from '~/components/VariablePickerPopover/VariablePickerPopover';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToRichTextEditor } from '~/utils/react-hook-form.utils';
import { DefaultValuePopover } from '../../TemplateVariables/DefaultValuePopover/DefaultValuePopover';
import { useRichTextVariableIntegration } from '../../TemplateVariables/hooks/useRichTextVariableIntegration';
import { VariableInsertButton } from '../../TemplateVariables/VariableInsertButton/VariableInsertButton';
import styles from './ExtraClause.module.scss';
export const GetExtraClauseTID = (parentTestId)=>getTestIds(parentTestId);
export default function ExtraClause(param) {
    let { showAgreementSettingsWarning, isReadOnly, onValidation, hideLabel = false, onChange = ()=>{} } = param;
    const { t: extraClauseTexts } = useLocaleKeys('components.agreementStudio.extraClause');
    const { control, formState, trigger } = useFormContext();
    const validation = richTextValidation('Notes');
    const editorElRef = useRef(null);
    const { enabled, toolbarButtonProps, pickerPopoverProps, defaultValuePopoverProps } = useRichTextVariableIntegration(editorElRef, {
        disabled: isReadOnly,
        testId: 'extra-clause',
        keyboardEnabled: !isReadOnly
    });
    useEffect(()=>{
        onValidation(formState.isValid);
    }, [
        formState,
        onValidation
    ]);
    useEffect(()=>{
        if (showAgreementSettingsWarning) trigger('extraClause');
    }, [
        showAgreementSettingsWarning,
        trigger
    ]);
    useOnMount(()=>{
        trigger('extraClause');
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !hideLabel && /*#__PURE__*/ _jsx(Typography, {
                style: {
                    paddingBottom: '8px'
                },
                className: styles.text,
                children: extraClauseTexts.addNoteLabel()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "extraClause",
                rules: validation,
                render: (renderProps)=>{
                    const connected = connectControllerToRichTextEditor(renderProps, {
                        alwaysShowErrors: true
                    });
                    const originalEditorRef = connected.editorRef;
                    return /*#__PURE__*/ _jsx(RichTextEditor, _object_spread_props(_object_spread({
                        editorHeight: 200,
                        placeholder: extraClauseTexts.placeholder(),
                        isReadOnly: isReadOnly,
                        testId: "formling-extra-clause-input",
                        bi: {
                            name: 'extra_clause'
                        }
                    }, connected, validation.dataAttr), {
                        editorRef: (el)=>{
                            editorElRef.current = el;
                            if (typeof originalEditorRef === 'function') {
                                originalEditorRef(el);
                            }
                        },
                        onChange: (v)=>{
                            onChange(v);
                            connected.onChange(v);
                        },
                        toolbarActions: enabled ? /*#__PURE__*/ _jsx(VariableInsertButton, _object_spread({}, toolbarButtonProps)) : null
                    }));
                }
            }),
            enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, pickerPopoverProps)),
            enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, defaultValuePopoverProps))
        ]
    });
}
